import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@elotech/angular-common';
import { MovimentacaoAfastamentoService } from '../../../../folha-pagamento/src/movimentacao-pessoal/movimentacao-afastamento.service';
import {
  MovimentacaoAfastamentoFichaFinanceira
} from '../../../../folha-pagamento/src/funcionario/detail/fucionario-detail/movimentacao-afastamento-ficha-financeira';

@Injectable()
export class PortalMovimentacaoAfastamentoService extends MovimentacaoAfastamentoService {

  private readonly resourcePortal: string = '/api/portal-servidor/afastamentos';

  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  public findByMovimentacaoFuncionarioAndCompetencia(funcionarioId: number, disableSpinner: boolean = true): Observable<MovimentacaoAfastamentoFichaFinanceira> {
    return this.httpClient.get({
      resource: `${this.resourcePortal}/by-funcionario-and-competencia/${funcionarioId}`,
      disableSpinner: disableSpinner
    });
  }
}
